import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToolListTemplate } from '@/templates/BossBaby';
import { useBossBabyTools } from '@/hooks/useBossBaby';
import { useSnackbar } from 'notistack';

export const ToolList: React.FC = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  
  const {
    tools,
    loading,
    total,
    page,
    limit,
    fetchTools,
    deleteTool,
    handlePageChange,
    handleRowsPerPageChange,
  } = useBossBabyTools();

  useEffect(() => {
    fetchTools();
  }, [fetchTools]);

  const handleSearch = (params: object) => {
    fetchTools(params);
  };

  const handleEdit = (toolId: number) => {
    navigate(`/boss-baby/tools/${toolId}/edit`);
  };

  const handleDelete = async (toolId: number) => {
    if (window.confirm('Are you sure you want to delete this tool?')) {
      try {
        await deleteTool(toolId);
        enqueueSnackbar('Tool deleted successfully', { variant: 'success' });
      } catch (error) {
        console.error('Delete error:', error);
      }
    }
  };

  const handleCreate = () => {
    navigate('/boss-baby/tools/create');
  };

  return (
    <ToolListTemplate
      tools={tools}
      loading={loading}
      total={total}
      page={page}
      limit={limit}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
      onSearch={handleSearch}
      onEdit={handleEdit}
      onDelete={handleDelete}
      onCreate={handleCreate}
    />
  );
};